import React from "react";
import { SocialMediaLinks, StyledContainer } from "./SocialMediaHelpers";

const SocialMedia: React.FC = () => {
  return (
    <StyledContainer>
      <div className="title" id="connect-with-sonesta">
        Connect with Sonesta
      </div>
      <SocialMediaLinks />
    </StyledContainer>
  );
};

export default SocialMedia;
